import React from "react";
import { useFormContext } from "react-hook-form";
import { CRow, CCol, CFormLabel, CFormInput } from "@coreui/react";

const Specifications = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const specs = watch("specifications") || [];

  // console.log("Current specifications values:", specs);

  // Recursive safe string converter
  const toStringSafe = (val) => {
    if (val === undefined || val === null) return "";
    if (typeof val === "object")
      return toStringSafe(val.value ?? val.label ?? JSON.stringify(val));
    return String(val);
  };

  // Handle input changes safely
  const handleValueChange = (index, newValue) => {
    const updated = [...specs];
    updated[index] = {
      ...updated[index],
      value: newValue === null ? "" : toStringSafe(newValue), // Ensure it's always a string
    };

    // console.log("Updated specifications:", updated); // Debugging: Check the updated value

    setValue("specifications", updated, {
      shouldDirty: true, // Mark field as dirty
      shouldTouch: true, // Mark field as touched
      shouldValidate: true, // Trigger validation
    });
  };

  return (
    <div
      style={{
        border: "1px solid #dcdcdc",
        borderRadius: "8px",
        padding: "1.5rem",
        position: "relative",
        marginBottom: "1.5rem",
      }}
    >
      <span
        style={{
          position: "absolute",
          top: "-0.8rem",
          left: "1rem",
          backgroundColor: "white",
          padding: "0 0.5rem",
          fontWeight: "600",
          color: "#333",
          fontSize: "1rem",
        }}
      >
        Product Specifications
      </span>

      {specs.length > 0 ? (
        specs
          .reduce((rows, spec, index) => {
            if (index % 3 === 0) rows.push([]);
            rows[rows.length - 1].push({ ...spec, index });
            return rows;
          }, [])
          .map((group, rowIndex) => (
            <CRow className="mb-3" key={rowIndex}>
              {group.map(({ label, value, input_type, index }) => (
                <CCol md={4} key={index}>
                  <CFormLabel>
                    {toStringSafe(label) || `Field ${index + 1}`}
                  </CFormLabel>
                  {input_type === "file" ? (
                    <CFormInput
                      type="file"
                      onChange={(e) =>
                        handleValueChange(index, e.target.files[0])
                      }
                    />
                  ) : (
                    <CFormInput
                      type={input_type || "text"}
                      placeholder={`Enter ${toStringSafe(label) || "value"}`}
                      value={toStringSafe(value)}
                      onChange={(e) => handleValueChange(index, e.target.value)}
                    />
                  )}
                  {errors.specifications?.[index]?.value?.message && (
                    <div
                      style={{
                        color: "red",
                        fontSize: "0.9em",
                        marginTop: "4px",
                      }}
                    >
                      {errors.specifications[index].value.message}
                    </div>
                  )}
                </CCol>
              ))}
            </CRow>
          ))
      ) : (
        <p className="text-muted">No specifications available.</p>
      )}
    </div>
  );
};

export default React.memo(Specifications);
